import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import Privacy from "./pages/Privacy";
import Termini from "./pages/Termini";
import Dashboard from "./pages/Dashboard";
import MemoryEditor from "./pages/MemoryEditor";
import AnteprimaCapsula from "./pages/AnteprimaCapsula";
import HeirPortal from "./pages/HeirPortal";
import AlbumFoto from "./pages/AlbumFoto";
import Testamento from "./pages/Testamento";
import TestamentoVista from "./pages/TestamentoVista";
import Piani from "./pages/Piani";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import AdminVerifications from "./pages/AdminVerifications";
import AlberoFamiglia from "./pages/AlberoFamiglia";
import ComeFunziona from "./pages/ComeFunziona";
import ComunicaScomparsa from "./pages/ComunicaScomparsa";
import Persone from "./pages/Persone";
import Doni from "./pages/Doni";
import RegistroInvii from "./pages/RegistroInvii";
import Libro from "./pages/Libro";

const Protected = ({ children }) => {
  const { user, checking } = useAuth();
  if (checking || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">Caricamento…</div>
    );
  if (!user) return <Navigate to="/accedi" replace />;
  return children;
};

const AdminProtected = ({ children }) => {
  const { user, checking } = useAuth();
  if (checking || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">Caricamento…</div>
    );
  if (!user) return <Navigate to="/accedi" replace />;
  if (user.role !== "admin") return <Navigate to="/ricordi" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/come-funziona" element={<ComeFunziona />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/termini" element={<Termini />} />
            <Route path="/comunica/:token" element={<ComunicaScomparsa />} />
            <Route path="/accedi" element={<Auth />} />
            <Route path="/erede/:token" element={<HeirPortal />} />
            <Route path="/testamento-vista/:token" element={<TestamentoVista />} />
            <Route path="/ricordi" element={<Protected><Dashboard /></Protected>} />
            <Route path="/libro" element={<Protected><Libro /></Protected>} />
            <Route path="/ricordi/nuovo" element={<Protected><MemoryEditor /></Protected>} />
            <Route path="/ricordi/:id" element={<Protected><MemoryEditor /></Protected>} />
            <Route path="/persone" element={<Protected><Persone /></Protected>} />
            <Route path="/tutori" element={<Navigate to="/persone" replace />} />
            <Route path="/eredi" element={<Navigate to="/persone" replace />} />
            <Route path="/anteprima" element={<Protected><AnteprimaCapsula /></Protected>} />
            <Route path="/album" element={<Protected><AlbumFoto /></Protected>} />
            <Route path="/albero-famiglia" element={<Protected><AlberoFamiglia /></Protected>} />
            <Route path="/doni" element={<Protected><Doni /></Protected>} />
            <Route path="/registro-invii" element={<Protected><RegistroInvii /></Protected>} />            <Route path="/testamento" element={<Protected><Testamento /></Protected>} />
            <Route path="/piani" element={<Protected><Piani /></Protected>} />
            <Route path="/verifica" element={<AdminProtected><AdminVerifications /></AdminProtected>} />
            <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
            <Route path="/payment/cancel" element={<Protected><PaymentCancel /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
